import React, { MouseEventHandler } from 'react';
import { NonTextLink } from '../../../../commonTypes/links';
import { scrollToElement } from '../../../../helpers/scroll';
import { applyComponentTheme } from '../../../../theme';
import { GridItem } from '../../../Grid';
import { MarketingPromoBadge, marketingPromoId } from '../../../MarketingPromo';
import { MarketingPromoGrid } from './styles';

export type HeroPromoProps = {
  heading: string;
  badgeHeading: string;
  badgeSubheading: string;
  onBadgeClick?: MouseEventHandler;
};

const HeroPromo: React.FC<HeroPromoProps> = ({
  heading,
  badgeHeading,
  badgeSubheading,
  onBadgeClick,
}) => {
  const marketingPromoSectionId = marketingPromoId(heading);
  const onMarketingPromoClick: MouseEventHandler = (event) => {
    event.preventDefault();
    if (onBadgeClick) {
      onBadgeClick(event);
    }
    scrollToElement(marketingPromoSectionId, 100);
  };
  const marketingPromoLink: NonTextLink = {
    url: encodeURI(`#${marketingPromoSectionId}`),
    onClick: onMarketingPromoClick,
  };
  return (
    <MarketingPromoGrid alignLeft>
      <GridItem desktop={9.5} tabletLandscape={9} tabletPortrait={5} mobile={0.8} />
      {/* We approximate the MarketingPromoBadge taking up 2 columns and the gutter for mobile and desktop */}
      <GridItem desktop={2.5} tabletLandscape={3} tabletPortrait={3} mobile={2.4}>
        <MarketingPromoBadge
          heading={badgeHeading}
          subheading={badgeSubheading}
          size="small"
          link={marketingPromoLink}
        />
      </GridItem>
    </MarketingPromoGrid>
  );
};

export default applyComponentTheme(HeroPromo, 'HeroPromo');
